import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'bs-acca-boost-icon',
    templateUrl: './acca-boost-icon.component.html',
    styleUrls: ['./acca-boost-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent],
})
export class AccaBoostIconComponent {
    @Input() iconSize = '14';
    @Input() showErrorIcon = false;
}
